import React from "react";

export default function DI() {
	return (
		<div>
			Senior Software Engineer | Dealer Alchemist | 2024 -{" "}
			<strong>Present</strong>
			<br />
			<em>Lone Tree, CO (Remote)</em>
			<br />
			<ul>
				<li>
					Built custom MUI-based components using React, Next, TypeScript, and
					MongoDB, resulting in a dynamic new analytics solution that pulls data
					from Matomo and displays important information to the clients. With
					this solution, analytics tracking and data collection went up 150% and
					is visible in a human-readable interface.
				</li>
				<li>
					Integrated a Google API for review collection and display, allowing
					clients to manage their reviews through an interactive dashboard using
					React, TypeScript, and Mongo. This solution improved client
					satisfaction by giving them a single place to manage their reviews.
				</li>
			</ul>
		</div>
	);
}
